const b = "DEFAULT";
var g = /* @__PURE__ */ ((r) => (r.privacyLink = "privacyLink", r.privacyPolicyCHD = "privacyPolicyCHD", r))(g || {});
const m = Object.freeze({
  API_ENDPOINT: "https://privacytermsprod.azureedge.net/privacy/privacy_and_terms_v2.json"
}), z = async () => {
  const r = await fetch(m.API_ENDPOINT);
  if (!r.ok)
    throw new Error(`HTTP error! Status: ${r.status}`);
  return await r.json();
}, D = (r, s) => s ? `${r}#${s}` : r, S = (r, s) => {
  let c = "Privacy Policy", e;
  return typeof r == "string" ? e = D(r, s) : (e = D(r == null ? void 0 : r.link, s), c = (r == null ? void 0 : r.text) || "Privacy Policy"), {
    link: e,
    text: c
  };
}, C = async ({
  appendix: r,
  countryCode: s,
  lang: c,
  linkType: e,
  state: E
}) => {
  var h, A, w, i, F, U, u, y, _, j, H, I, N;
  try {
    const o = await z(), O = s && s in o, T = O && E, $ = O && !E, P = (A = (h = o[b]) == null ? void 0 : h.en) == null ? void 0 : A[e], t = s ? o == null ? void 0 : o[s] : null;
    let v = "";
    return T && (v = ((i = (w = t == null ? void 0 : t[E]) == null ? void 0 : w[c]) == null ? void 0 : i[e]) || ((U = (F = t == null ? void 0 : t.DEFAULT) == null ? void 0 : F[c]) == null ? void 0 : U[e]) || ((y = (u = o.DEFAULT) == null ? void 0 : u[c]) == null ? void 0 : y[e]) || P), $ && (v = ((_ = t == null ? void 0 : t[c]) == null ? void 0 : _[e]) || ((H = (j = t == null ? void 0 : t.DEFAULT) == null ? void 0 : j[c]) == null ? void 0 : H[e]) || ((N = (I = o.DEFAULT) == null ? void 0 : I[c]) == null ? void 0 : N[e]) || P), S(v || P, r);
  } catch (o) {
    console.error("Error:", o);
    return;
  }
};
export {
  g as PrivacyLinkType,
  C as generatePrivacyObject
};
